import { Sanity$OtovoSignupFormSection } from '@otovo/shared/types/sanityTypes';
import dynamic from 'next/dynamic';
import InstantActivationForm from './InstantActivationForm';

const CareSignupForm = dynamic(() => import('./CareSignupForm'));

function assertExhaustiveCheck(type: never) {
  throw new Error(`Unhandled formType passed to SignupSectionWrapper: ${type}`);
}

type Props = {
  content: Sanity$OtovoSignupFormSection;
};

const SignupSectionWrapper = ({ content }: Props) => {
  const formType = content.formType;
  switch (formType) {
    case 'careSignup':
      return <CareSignupForm content={content} />;
    case 'instantActivation':
      return <InstantActivationForm content={content} />;
    default:
      assertExhaustiveCheck(formType);
  }
};

export default SignupSectionWrapper;
